import { PortableText, PortableTextReactComponents } from '@portabletext/react'
import type { PortableTextBlock } from '@portabletext/types'

interface RichTextProps {
  value: PortableTextBlock | PortableTextBlock[]
  components: Partial<PortableTextReactComponents>
}

const RichText = ({ value, components }: RichTextProps) => {
  return (
    <PortableText
      value={value}
      components={components}
      onMissingComponent={false}
    />
  )
}

export default RichText
